import { useState, useEffect } from "react";
import TickerAnimation from "../TickerAnimation";

const DataActionField = ({
  label,
  value,
  subLabel,
  icon,
  hoverIcon,
  hoverEnabled,
  onClick,
  disabled = false,
  formatter,
}) => {
  const [currentIcon, setCurrentIcon] = useState(icon);
  const formattedValue = formatter ? formatter(value) : value;

  useEffect(() => {
    setCurrentIcon(icon);
  }, [icon]);

  return (
    <div className="w-full">
      {label && (
        <p
          className={` font-semibold text-base text-text-primary mb-margin-md ${disabled ? "opacity-light-opacity pointer-events-none" : ""}`}
        >
          {label}
        </p>
      )}

      {subLabel && (
        <p className="text-font-sm text-text-secondary mb-margin-xs">
          {subLabel}
        </p>
      )}

      <div
        className={`w-width-full lg:max-w-[var(--create-box-width)] flex items-center rounded-border-radius-md bg-primary-nav
        ${disabled ? "opacity-light-opacity pointer-events-none" : ""}`}
      >
        <div className="flex-1 relative z-z-index-header flex items-center pr-padding-md pl-padding-md my-margin-sm overflow-hidden border-r border-primary-bg">
          <div className="w-full text-text-primary text-sm break-all pr-padding-xs">
            <TickerAnimation text={formattedValue} />
          </div>
        </div>

        <div
          className={`flex items-center justify-center pl-padding-sm pr-padding-button-l py-padding-button-l flex-shrink-0 ${hoverEnabled ? "global-hover-white cursor-pointer" : " "} relative z-z-index-base rounded-r-border-radius-md`}
          onClick={onClick}
        >
          <img
            src={currentIcon}
            alt="action"
            className="w-icon-sm h-icon-sm"
            onMouseOver={() => hoverIcon && setCurrentIcon(hoverIcon)}
            onMouseOut={() => setCurrentIcon(icon)}
          />
        </div>
      </div>
    </div>
  );
};

export default DataActionField;
